import { render, staticRenderFns } from "./NameserverListItem.vue?vue&type=template&id=381b020a&scoped=true"
import script from "./NameserverListItem.vue?vue&type=script&lang=js"
export * from "./NameserverListItem.vue?vue&type=script&lang=js"
import style0 from "./NameserverListItem.vue?vue&type=style&index=0&id=381b020a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381b020a",
  null
  
)

export default component.exports